import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TransactionBidDropdown from "./transaction-bid-dropdown";

function mapStateToProps(state) {
  return {
    transactions: state.transactions,
    bids: state.bids,
    errorFields: state.onSubmitDetails.errorFields,
    errorFlag: state.onSubmitDetails.errorFlag,
    actionType: state.actionType,
  };
}
function mapDispatchToProps(dispatch) {
  let actionDispatchers = bindActionCreators(actionCreators, dispatch);
  return actionDispatchers;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionBidDropdown);
